import {AxiosPromise} from 'axios';
import {createAction} from 'redux-act';

import {ENDPOINTS} from 'constants/endpoints';
import {API_URL} from 'constants/api';
import {DEFAULT_COUNTRY} from 'constants/location';
import {instanceGusaBackend} from 'libs/api';

import {CountryType, RegionsItemType} from 'reducers/location/locationType';

export const defaultState = {
    countries: [{value: DEFAULT_COUNTRY, label: 'United States'}],
    states: {
        [DEFAULT_COUNTRY]: [],
    },
};

/**
 * Request countries descriptions list by API
 *
 * @returns {AxiosPromise<CountryType>}
 */
export const fetchCountries = createAction<AxiosPromise<CountryType[]>>('FETCH_COUNTRIES', () =>
    instanceGusaBackend({
        method: 'get',
        url: `${ENDPOINTS.COUNTRIES_GET}`,
        baseURL: API_URL,
    }),
);

export type FetchStatesActionMetaType = {country: string};

/**
 * Request country's regions list
 *
 * @param {string} [countryCode='US'] - country code
 * @returns {AxiosPromise<RegionsItemType>}
 */
export const fetchRegions = createAction<AxiosPromise<RegionsItemType>, FetchStatesActionMetaType>(
    'FETCH_STATES',
    (countryCode: string = DEFAULT_COUNTRY) =>
        instanceGusaBackend({
            method: 'get',
            url: `${ENDPOINTS.REGIONS_GET({country: countryCode})}`,
            baseURL: API_URL,
        }),
    (country: string = DEFAULT_COUNTRY) => ({country}),
);
